import { render, staticRenderFns } from "./interpretation.vue?vue&type=template&id=66656e0d&scoped=true"
import script from "./interpretation.vue?vue&type=script&lang=js"
export * from "./interpretation.vue?vue&type=script&lang=js"
import style0 from "./interpretation.vue?vue&type=style&index=0&id=66656e0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66656e0d",
  null
  
)

export default component.exports